import React from "react"
import PropTypes from "prop-types"

import { Link } from "react-router-dom"

const ConditionalLink = ({ to, isExternal, className, onClick, openInNewTab, children, isFragment }) => {
    const onClickHandler = (event) => {
        if (typeof onClick === "function") {
            onClick(event)
        }
    }
    if (to) {
        if (isExternal) {
            return (
                <a
                    href={to}
                    className={className}
                    onClick={onClickHandler}
                    target={openInNewTab ? "_blank" : ""}
                    rel="noreferrer"
                >
                    {children}
                </a>
            )
        }
        return (
            <Link to={to} className={className} onClick={onClickHandler}>
                {children}
            </Link>
        )
    } else {
        //This case is to ensure that when classnames are passed to a fragment it gets turned into a div instead
        if (isFragment && className) {
            return <div className={className}>{children}</div>
        } else if (isFragment) {
            return <>{children}</>
        } else {
            return (
                <div className={className} onClick={onClickHandler}>
                    {children}
                </div>
            )
        }
    }
}

ConditionalLink.propTypes = {
    to: PropTypes.string,
    isExternal: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
    openInNewTab: PropTypes.bool,
    children: PropTypes.node.isRequired,
    isFragment: PropTypes.bool,
}

export default ConditionalLink
